import { getMethod, postMethod } from '../../api/methods'
import API_ROUTES from '../../api/routes'

const {
  GET_REPORT_LIST,
  GET_COLUMN_LIST,
  GET_REPORT_HISTORY_LIST,
  POST_EXPORT_TO_EXCEL,
  GET_SALES_REPORT_LIST,
  GET_STOCK_REPORT_LIST,
  GET_FLEXIBLE_REPORT_DATA,
  SAVE_FLEXIBLE_REPORT,
  GET_SAVE_FLEXIBLE_REPORT,
  GET_SINGLE_REPORT,
  GET_FLEXIBLE_REPORT_CALCULATION,
  GET_SINGLE_ACTIVE_JOBS_REPORT,
} = API_ROUTES

const getReportListApi = async ({ params }) => {
  const response = await getMethod(GET_REPORT_LIST({ params }))
  return response?.data
}
const getColumnListApi = async ({ params }) => {
  const response = await getMethod(GET_COLUMN_LIST({ params }))
  return response?.data
}

const exportToExcelApi = async ({ payload }) => {
  const response = await postMethod(POST_EXPORT_TO_EXCEL, payload)
  return response?.data
}

const getReportHistoryListApi = async ({ params }) => {
  const response = await getMethod(GET_REPORT_HISTORY_LIST({ params }))
  return response?.data
}

const getSalesReportListApi = async ({ params }) => {
  const response = await getMethod(GET_SALES_REPORT_LIST({ params }))
  return response?.data
}

const getStockReportListApi = async ({ params }) => {
  const response = await getMethod(GET_STOCK_REPORT_LIST({ params }))
  return response?.data
}

const getFlexibleReportDataApi = async ({ payload, pageNo = 1 }) => {
  const response = await postMethod(
    GET_FLEXIBLE_REPORT_DATA({ pageNo }),
    payload,
  )
  return response?.data
}
const saveFlexibleReportApi = async ({ payload }) => {
  const response = await postMethod(SAVE_FLEXIBLE_REPORT, payload)
  return response?.data
}

const getSaveReportListApi = async ({ params }) => {
  const response = await getMethod(GET_SAVE_FLEXIBLE_REPORT({ params }))
  return response?.data
}
const getSaveColumnListApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(`${SAVE_FLEXIBLE_REPORT}/${pageNo}`, {
    params,
  })
  return response?.data
}

const getSingleReportApi = async ({ params }) => {
  const response = await getMethod(GET_SINGLE_REPORT({ params }))
  return response?.data
}

const getFlexibleReportCalculationApi = async ({ payload }) => {
  const response = await postMethod(GET_FLEXIBLE_REPORT_CALCULATION, payload)
  return response?.data
}

const getSingleActiveJobsReportApi = async ({ params }) => {
  const response = await getMethod(GET_SINGLE_ACTIVE_JOBS_REPORT({ params }))
  return response?.data
}

export {
  getReportListApi,
  exportToExcelApi,
  getColumnListApi,
  getReportHistoryListApi,
  getSalesReportListApi,
  getStockReportListApi,
  getFlexibleReportDataApi,
  saveFlexibleReportApi,
  getSaveReportListApi,
  getSingleReportApi,
  getFlexibleReportCalculationApi,
  getSingleActiveJobsReportApi,
  getSaveColumnListApi,
}
